import React from 'react';
import { ObjectsWithViewer } from 'components/collection/objects-with-viewer';
import FilterSet from 'components/controls/filters/filterset';
import ObjectGridTruncated from 'components/collection/object-grid-truncated';
import { lofiArtworkObjectModel } from 'helpers/collection';
import styles from '../collection-object-package-page.module.scss';
import type { IJSONFriendlyObjectPackage } from '@metmuseum/types';

export default function ArtworkTabPanel({
	filter,
	objectPackage,
	perLoad,
}: ArtworksTabPanelProps) {
	const [artistFilter, setArtistFilter] = React.useState('All');
	const formattedObjects = objectPackage.objects.map(lofiArtworkObjectModel);
	const primaryArtists = new Set(
		formattedObjects
			.map((object) => object.primaryArtist)
			.sort((a, b) =>
				a
					.split(' ')
					.pop()
					.toLowerCase()
					.localeCompare(b.split(' ').pop().toLowerCase()),
			)
			.flat(),
	);
	const artistsStrings = ['All', ...primaryArtists];
	const filterOpts = artistsStrings
		.filter(Boolean)
		.map((artist) => ({ name: artist, value: artist }));
	const filteredArtworks =
		artistFilter === 'All'
			? formattedObjects
			: formattedObjects.filter((artWork) =>
					artWork?.primaryArtist?.includes(artistFilter),
				);

	const handleArtistChange = (event) => {
		if (event.target.checked) {
			setArtistFilter(event.target.name);
		} else {
			setArtistFilter('All');
		}
	};

	return (
		<div className={styles.tabPanelContent}>
			{filter && (
				<div className={styles.filters}>
					<FilterSet
						key={artistFilter}
						labelText="Filter by artist:"
						filtersFor="Artworks"
						filterOptions={filterOpts}
						filterState={filterOpts.reduce((filterState, filter) => {
							filterState[filter.value] = artistFilter === filter.value;
							return filterState;
						}, {})}
						handleInputChange={handleArtistChange}
						screenReaderLegend="Select optional categories to filter results"
						sideForChildren="right"
					/>
				</div>
			)}
			<div className={styles.objectsViewerWrapper}>
				<ObjectsWithViewer
					enforceMaxObjectWidth={true}
					objects={filteredArtworks}
					objectPackageID={objectPackage.id}
					Container={ObjectGridTruncated}
					containerProps={{ perLoad }}
				/>
			</div>
		</div>
	);
}

interface ArtworksTabPanelProps {
	filter?: boolean;
	objectPackage?: IJSONFriendlyObjectPackage;
	perLoad?: number;
}
